<div class="bulk-delete-toolbar">
  <button
    *ngIf="!selectionMode"
    mat-stroked-button
    color="warn"
    type="button"
    class="bulk-delete-toolbar__button"
    [UserAccessibility]="deletePermission"
    matTooltip="Enable selection to delete multiple records"
    (click)="onToggleMode()">
    <mat-icon class="me-1">delete_outline</mat-icon>
    {{ bulkButtonLabel }}
  </button>

  <ng-container *ngIf="selectionMode">
    <button
      mat-stroked-button
      type="button"
      class="bulk-delete-toolbar__button"
      matTooltip="Exit bulk selection mode"
      (click)="onToggleMode()">
      <mat-icon class="me-1">close</mat-icon>
      Cancel
    </button>

    <button
      mat-button
      type="button"
      class="bulk-delete-toolbar__button"
      [disabled]="selectableCount === 0 || isAllSelected"
      matTooltip="Select all eligible rows"
      (click)="onSelectAll()">
      Select All
    </button>

    <button
      mat-button
      type="button"
      class="bulk-delete-toolbar__button"
      [disabled]="selectedCount === 0"
      matTooltip="Clear current selection"
      (click)="onClearSelection()">
      Clear
    </button>

    <button
      mat-raised-button
      color="warn"
      type="button"
      class="bulk-delete-toolbar__button bulk-delete-toolbar__button--danger"
      [disabled]="selectedCount === 0"
      [swal]="bulkDeleteConfirmSwal"
      [UserAccessibility]="deletePermission"
      matTooltip="Delete selected records">
      <mat-icon class="me-1">delete</mat-icon>
      {{ deleteSelectedText }}
    </button>
  </ng-container>
</div>

<swal
  #bulkDeleteConfirmSwal
  [title]="confirmTitle"
  [text]="confirmText"
  icon="question"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="onDeleteRequested()">
</swal>
